const cents = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

const whole = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
});

const dollars = (value, withCents = false)=> {
	if (value === undefined || value === null || value === '') return '';

	const num = Number(value);

	// Check for NaN
	if (num !== num) return '';
	return withCents ? cents.format(num) : whole.format(num);
};

export default dollars;

// Money cells that must never be blank: unset/empty/invalid all render as $0.00.
export const dollarsOrZero = (value, withCents = false) => {
	const formatted = dollars(value, withCents);
	return formatted === '' ? dollars(0, withCents) : formatted;
};